module.exports = __webpack_public_path__ + "static/img/IS.192b9bdd.jpg";